import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { socialLogin, setSessionData } from "../actions/session";
import { Spinner } from "../assets";
import { getCookies } from "../helpers";

export default function Authenticator({ provider }) {

	const dispatch = useDispatch();
	const history = useHistory();
	const { redirect_to } = getCookies();

	const { loading, user, query, loginError } = useSelector(state => state.session);
	const { access_token } = query;

	useEffect(() => {
		if (access_token) dispatch(socialLogin({ provider, access_token }));
	}, [dispatch, provider, access_token]);

	// Get out of here if there's no access token/provider, or we're done logging in.
	if (!access_token || user)
		return <Redirect to={redirect_to || "/"} />;

	if (loading) return <Spinner />;

	return Boolean(loginError) ?
		<section className="loginError" style={{
			marginTop: "20vh"
		}}>
			<h4>Something went wrong</h4>
			<div className="inner">
				<br />
				There was a problem logging you in. Are you sure you used the right provider?
				<br /><br />
				If you created your account with Facebook/Google, you have to use the same provider to log back in.
				<br/><br/>
			</div>
			<div className="inner">
				<button className="brand-bg" onClick={e => {
					dispatch(setSessionData({ loginError: null }));
					history.push(redirect_to || "/");
				}}>Go Back</button>
			</div>
		</section>
		:
		<section style={{
			marginTop: "20vh"
		}}>
			<Spinner />
		</section>
}